import * as React from 'react'

export const ValidVisitIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={57} height={57} viewBox="0 0 57 57" fill="none">
    <circle cx={28.5} cy={28.5} r={28.5} fill={'#FFEBF3'} />
    <path
      stroke={'#E12468'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M37 37v-2a4 4 0 0 0-4-4h-8a4 4 0 0 0-4 4v2M29 27a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
    />
  </svg>
)
